import React from 'react';
import classNames from 'classnames';

import css from './IconKitchen.module.css';

/**
 * IconKitchen icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconKitchen = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_2509_4235)">
<path d="M10.6167 7.15752C10.6167 3.96239 7.15788 1.96544 4.39082 3.56301C3.10663 4.30444 2.31553 5.67466 2.31553 7.15752C2.31553 10.3526 5.77435 12.3496 8.54141 10.752C9.82561 10.0106 10.6167 8.64038 10.6167 7.15752ZM12.5364 8.54105C11.9094 11.3124 9.42773 13.3834 6.46612 13.3834C3.02891 13.3834 0.240234 10.5947 0.240234 7.15752C0.240234 3.72031 3.02891 0.931641 6.46612 0.931641C9.42773 0.931641 11.9094 3.00261 12.5364 5.77399H15.6406C16.0211 5.35029 16.5745 5.08223 17.1885 5.08223H21.6849C22.8307 5.08223 23.7602 6.01179 23.7602 7.15752C23.7602 8.30325 22.8307 9.23282 21.6849 9.23282H17.1885C16.5745 9.23282 16.0211 8.96476 15.6406 8.54105H12.5364ZM6.46612 4.39046C8.5962 4.39037 9.92748 6.69619 8.86252 8.54095C8.36825 9.39713 7.45473 9.92458 6.46612 9.92458C4.33603 9.92467 3.00475 7.61885 4.06971 5.7741C4.56398 4.91791 5.4775 4.39046 6.46612 4.39046ZM17.5344 11.3081C18.1094 11.3081 18.572 11.7707 18.572 12.3458V12.6916H22.7226C23.2976 12.6916 23.7602 13.1543 23.7602 13.7293C23.7602 14.3043 23.2976 14.7669 22.7226 14.7669H12.3461C11.7711 14.7669 11.3085 14.3043 11.3085 13.7293C11.3085 13.1543 11.7711 12.6916 12.3461 12.6916H16.4967V12.3458C16.4967 11.7707 16.9593 11.3081 17.5344 11.3081ZM12.692 20.9928V16.1505H22.3767V20.9928C22.3767 22.1385 21.4471 23.0681 20.3014 23.0681H14.7673C13.6216 23.0681 12.692 22.1385 12.692 20.9928ZM2.31553 14.7669H7.84965C8.99538 14.7669 9.92494 15.6965 9.92494 16.8422C9.92494 17.988 8.99538 18.9175 7.84965 18.9175H7.15788C7.15788 19.6828 6.53962 20.301 5.77435 20.301H3.00729C2.24203 20.301 1.62376 19.6828 1.62376 18.9175V15.4587C1.62376 15.0782 1.93506 14.7669 2.31553 14.7669ZM7.84965 17.534C8.23012 17.534 8.54141 17.2227 8.54141 16.8422C8.54141 16.4618 8.23012 16.1505 7.84965 16.1505H7.15788V17.534H7.84965ZM1.27788 20.9928H8.88729C9.46232 20.9928 9.92494 21.4554 9.92494 22.0305C9.92494 22.6055 9.46232 23.0681 8.88729 23.0681H1.27788C0.702851 23.0681 0.240234 22.6055 0.240234 22.0305C0.240234 21.4554 0.702851 20.9928 1.27788 20.9928Z" fill="#262338"/>
</g>
<defs>
<clipPath id="clip0_2509_4235">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};

export default IconKitchen;

